module.exports = __webpack_public_path__ + "img/Literatura.0a134b0d.png";